import { TooltipHandlers, TooltipState } from '@/components'

/** Ensures only one portal tooltip is visible at a time across cells. */
let hideActiveTooltip: (() => void) | null = null

export const claimActiveTooltip = (hide: () => void) => {
	if (hideActiveTooltip && hideActiveTooltip !== hide) {
		hideActiveTooltip()
	}
	hideActiveTooltip = hide
}

export const releaseActiveTooltip = (hide: () => void) => {
	if (hideActiveTooltip === hide) {
		hideActiveTooltip = null
	}
}

export const createTooltipHandlers = (
	title: string | undefined,
	state: TooltipState,
	setState: {
		setShowTooltip: (isShown: boolean) => void
		setTooltipPosition: (pos: { left: number; top: number }) => void
	},
	hide?: () => void,
): Pick<TooltipHandlers, 'handleMouseEnter' | 'handleMouseLeave'> => ({
	handleMouseEnter: (event: React.MouseEvent<HTMLDivElement>) => {
		if (!title || state.isMenuOpen) return

		const rect = event.currentTarget.getBoundingClientRect()
		const positionFromBottomPx = 8

		setState.setTooltipPosition({
			top: rect.bottom + positionFromBottomPx,
			left: rect.left,
		})
		if (hide) {
			claimActiveTooltip(hide)
		}
		setState.setShowTooltip(true)
	},

	handleMouseLeave: () => {
		if (hide) {
			hide()
		} else {
			setState.setShowTooltip(false)
		}
	},
})
